(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer-recommendations"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-drawer-recommendations')) {
    customElements.define(
      'cart-drawer-recommendations',
      class CartDrawerRecommendations extends HTMLElement {
        constructor() {
          super();
          this.intent = this.dataset.intent || 'related';
          this.strategy = this.dataset.strategy || 'last_added';
          this.limit = parseInt(this.dataset.limit) || 4;
          this.abortController = null;
          this.currentProductId = null;
        }

        async connectedCallback() {
          // Subscribe to PUB_SUB_EVENTS for cart updates
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
              // When cart updates, reload recommendations AND check tracking with single cart fetch
              this.loadRecommendationsAndCheckTracking();
            });
          }

          // Load initial recommendations and check for pending tracking
          await this.loadRecommendationsAndCheckTracking();
        }

        async loadRecommendationsAndCheckTracking() {
          // Get cart items once
          const cart = await this.getCart();

          // Load recommendations
          await this.loadRecommendationsFromCart(cart);

          // Check for pending tracking using the same cart data
          const storageKey = 'cart_recommendation_clicks';
          const clicks = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
          if (clicks.length > 0 && cart) {
            // Pass the cart data to avoid refetching
            await this.checkAndTrackAddToCart(cart);
          }
        }

        disconnectedCallback() {
          // Unsubscribe from PUB_SUB_EVENTS
          if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
          }

          if (this.abortController) {
            this.abortController.abort();
          }
          // Destroy swiper instance
          if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
          }
        }

        async loadRecommendationsFromCart(cart) {
          if (!cart || !cart.items || cart.items.length === 0) {
            this.innerHTML = '';
            this.currentProductId = null;
            return;
          }

          // Pick the best product from cart to base recommendations on
          const selectedProduct = this.selectProductFromCart(cart.items);

          if (!selectedProduct) {
            this.innerHTML = '';
            this.currentProductId = null;
            return;
          }

          // Only fetch if product changed (avoid unnecessary requests)
          if (selectedProduct.product_id === this.currentProductId) {
            return;
          }

          this.currentProductId = selectedProduct.product_id;

          // Fetch recommendations using cart template
          await this.fetchRecommendationsSection(selectedProduct.product_id);
        }

        async getCart() {
          try {
            const response = await fetch('/cart.js');
            return await response.json();
          } catch (error) {
            return null;
          }
        }

        selectProductFromCart(items) {
          // Strategy: Pick the most expensive item (highest price * quantity)
          // This tends to be the main product, accessories are usually cheaper
          if (!items || items.length === 0) return null;

          if (this.strategy == 'last_added') {
            // Return the last item in the array (most recently added)
            return items[items.length - 1];
          } else {
            return items.reduce((selected, item) => {
              const currentValue = item.price * item.quantity;
              const selectedValue = selected ? selected.price * selected.quantity : 0;
              return currentValue > selectedValue ? item : selected;
            }, null);
          }
        }

        async fetchRecommendationsSection(productId) {
          // Cancel any pending request
          if (this.abortController) {
            this.abortController.abort();
          }

          this.abortController = new AbortController();

          try {
            // Use Shopify's recommendations endpoint with section rendering
            // This is the SAME approach as related-products section
            const url = `/recommendations/products?product_id=${productId}&section_id=cart-drawer-recommendations&limit=${this.limit}&intent=${this.intent}`;

            const response = await fetch(url, { signal: this.abortController.signal });

            if (!response.ok) {
              throw new Error('Failed to fetch recommendations');
            }

            const responseText = await response.text();
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = responseText;

            // Extract the section wrapper element (same as product-recommendations)
            const sectionWrapper = tempDiv.querySelector(
              'cart-drawer-recommendations-section .cart-drawer-recommendations'
            );

            if (sectionWrapper?.innerHTML.trim().length) {
              // Replace with server-rendered content
              this.innerHTML = sectionWrapper.innerHTML;

              // Initialize Yotpo widgets if available
              if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
                window.yotpoWidgetsContainer.initWidgets(false);
              }

              // Initialize interactive elements (quick-add, swatches)
              this.initializeInteractiveElements();
            } else {
              // No recommendations found
              this.innerHTML = '';
            }
          } catch (error) {
            if (error.name !== 'AbortError') {
              this.innerHTML = '';
            }
          }
        }

        initializeInteractiveElements() {
          // Quick-add buttons are handled automatically by modal-opener custom elements
          // Add tracking for quick-add clicks
          this.setupQuickAddTracking();

          // Track recommendation impressions (view_item_list)
          this.trackRecommendationImpressions();

          // Initialize Swiper slider
          this.initializeSwiper();
          this.classList.add('initialized');
          // Initialize color swatches (if they exist from card-product snippet)
          const swatchGroups = this.querySelectorAll('.card__swatches, .o-swatches__swatch-options');
          swatchGroups.forEach((group) => {
            const buttons = group.querySelectorAll('[data-colour-swatch-button]');
            if (buttons.length > 0) {
              // Set first swatch as active
              buttons[0].classList.add('active');

              // Add event listeners if not already added
              buttons.forEach((button) => {
                if (!button.dataset.listenerAdded) {
                  button.addEventListener('click', this.handleSwatchClick.bind(this));
                  button.addEventListener('mouseenter', this.handleSwatchClick.bind(this));
                  button.dataset.listenerAdded = 'true';
                }
              });
            }
          });
        }

        initializeSwiper() {
          // Destroy existing swiper if it exists
          if (this.swiper) {
            this.swiper.destroy(true, true);
          }

          // Initialize new swiper
          const swiperContainer = this.querySelector('.cart-drawer-recommendations__swiper');
          if (swiperContainer && typeof Swiper !== 'undefined') {
            this.swiper = new Swiper(swiperContainer, {
              slidesPerView: 1,
              spaceBetween: 10,
              mousewheel: {
                forceToAxis: true,
              },
              breakpoints: {
                430: {
                  slidesPerView: 1.1,
                },
                452: {
                  slidesPerView: 1.2,
                },
              },
              navigation: {
                nextEl: '.cart-drawer-recommendations__nav-next',
                prevEl: '.cart-drawer-recommendations__nav-prev',
              },
            });
          }
        }

        setupQuickAddTracking() {
          // Track quick-add button clicks (desktop modal)
          const quickAddButtons = this.querySelectorAll('modal-opener button, quick-add-modal button');
          quickAddButtons.forEach((button) => {
            if (!button.dataset.trackingAdded) {
              button.addEventListener('click', (e) => {
                const productData = this.getProductDataFromCard(
                  button.closest('.product-card-wrapper, .card, .swiper-slide')
                );
                if (productData) {
                  this.trackRecommendationClick(button);
                  // Save to session storage for desktop too (in case modal is opened but cart updated event happens)
                  this.saveClickedProduct(productData);
                }
              });
              button.dataset.trackingAdded = 'true';
            }
          });

          // Track mobile product link clicks - save to session storage
          const mobileLinks = this.querySelectorAll('.quick-add__mobile-link');
          mobileLinks.forEach((link) => {
            if (!link.dataset.trackingAdded) {
              link.addEventListener('click', (e) => {
                const productData = this.getProductDataFromCard(
                  link.closest('.product-card-wrapper, .card, .swiper-slide')
                );
                if (productData) {
                  this.trackRecommendationClick(link);
                  // Save to session storage - user is navigating to PDP
                  this.saveClickedProduct(productData);
                }
              });
              link.dataset.trackingAdded = 'true';
            }
          });

          // Note: Cart update tracking is now handled via PUB_SUB_EVENTS.cartUpdate
          // in the connectedCallback method above
        }

        saveClickedProduct(productData) {
          try {
            const storageKey = 'cart_recommendation_clicks';
            let clicks = JSON.parse(sessionStorage.getItem(storageKey) || '[]');

            // Add timestamp to track when clicked
            const clickData = {
              ...productData,
              clickedAt: Date.now(),
              intent: this.intent,
            };

            // Remove duplicates (same product clicked multiple times)
            clicks = clicks.filter((item) => item.id !== productData.id);

            // Add new click
            clicks.push(clickData);

            // Keep only last 10 clicks to prevent storage bloat
            if (clicks.length > 10) {
              clicks = clicks.slice(-10);
            }

            sessionStorage.setItem(storageKey, JSON.stringify(clicks));
          } catch (error) {
            // Silently fail if session storage is unavailable
          }
        }

        async checkAndTrackAddToCart(cartData = null) {
          try {
            const storageKey = 'cart_recommendation_clicks';
            let clicks = JSON.parse(sessionStorage.getItem(storageKey) || '[]');

            if (clicks.length === 0) {
              return;
            }

            // Get current cart to check what was just added (use provided cart or fetch fresh)
            const cart = cartData || (await this.getCart());
            if (!cart || !cart.items) {
              return;
            }

            // Store the last tracked timestamp to avoid tracking old additions
            const lastTrackedKey = 'cart_recommendation_last_tracked';
            const lastTrackedTime = parseInt(sessionStorage.getItem(lastTrackedKey) || '0');
            const currentTime = Date.now();

            // Check if any clicked products are now in cart
            const trackedProducts = [];
            clicks.forEach((clickData) => {
              // Find ALL instances of this product in cart by PRODUCT ID only (not variant)
              const matchingItems = cart.items.filter((item) => {
                const itemProductId = item.product_id?.toString();
                const clickProductId = clickData.productId?.toString();

                // Match ONLY by product ID (variant doesn't matter)
                return itemProductId && clickProductId && itemProductId === clickProductId;
              });

              if (matchingItems.length > 0) {
                // Find the most recently added item (highest index in cart)
                // Cart items are ordered with most recent additions at the end
                const mostRecentItem = matchingItems[matchingItems.length - 1];

                // Only track if this is a NEW addition (since last check)
                // We use the click timestamp to determine if this was a recent click
                if (clickData.clickedAt > lastTrackedTime) {
                  // Create product data from ACTUAL cart item (not clicked product)
                  const actualCartData = {
                    name: mostRecentItem.product_title,
                    productId: mostRecentItem.product_id?.toString(),
                    handle: mostRecentItem.handle,
                    variantId: mostRecentItem.variant_id?.toString(),
                    price: mostRecentItem.price / 100, // Convert cents to dollars
                    currency: cart.currency || clickData.currency, // Get from cart API response
                    brand: mostRecentItem.vendor || 'Solbari',
                    variant: mostRecentItem.variant_title || '',
                    category: mostRecentItem.product_type || '',
                    quantity: mostRecentItem.quantity || 1,
                    position: clickData.position, // Keep original position from recommendation
                    intent: clickData.intent, // Keep original intent
                  };

                  // Track with ACTUAL cart data (not the clicked product data)
                  this.trackRecommendationAddToCart(null, actualCartData);

                  trackedProducts.push(clickData.productId);
                }
              }
            });

            // Update last tracked timestamp
            if (trackedProducts.length > 0) {
              sessionStorage.setItem(lastTrackedKey, currentTime.toString());
            }

            // Remove tracked products from session storage
            if (trackedProducts.length > 0) {
              clicks = clicks.filter((item) => !trackedProducts.includes(item.productId));
              sessionStorage.setItem(storageKey, JSON.stringify(clicks));
            }

            // Clean up old clicks (older than 30 minutes)
            const thirtyMinutesAgo = Date.now() - 30 * 60 * 1000;
            clicks = clicks.filter((item) => item.clickedAt > thirtyMinutesAgo);
            sessionStorage.setItem(storageKey, JSON.stringify(clicks));
          } catch (error) {
            // Silently fail if session storage is unavailable
          }
        }

        trackRecommendationClick(element) {
          const card = element.closest('.product-card-wrapper, .card, .swiper-slide');
          if (!card) return;

          const productData = this.getProductDataFromCard(card);
          if (!productData) return;

          const eventData = {
            event: 'cart_recommendation_click',
            product_name: productData.name,
            product_id: productData.productId,
            product_handle: productData.handle,
            product_price: productData.price,
            product_brand: productData.brand,
            product_variant: productData.variant,
            product_variant_id: productData.variantId,
            product_category: productData.category,
            product_position: productData.position,
            currency: productData.currency,
            list_name: 'Cart Drawer Recommendations',
            recommendation_source: 'cart_drawer',
            recommendation_intent: this.intent,
          };

          // Send to GTM (dataLayer)
          if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push(eventData);
          }

          // Send to GA4 directly (gtag) if available
          if (typeof window.gtag === 'function') {
            window.gtag('event', 'select_item', {
              item_list_name: 'Cart Drawer Recommendations',
              item_list_id: 'cart_drawer_recommendations',
              items: [{
                item_id: productData.productId,
                item_name: productData.name,
                item_brand: productData.brand,
                item_category: productData.category,
                item_variant: productData.variant,
                price: productData.price,
                currency: productData.currency,
                index: productData.position,
              }],
            });
          }
        }

        trackRecommendationAddToCart(modal, cartData = null) {
          let productData = cartData;

          // If no cartData provided, try to get from modal (desktop flow - rare case)
          if (!productData && modal) {
            const card = modal.closest('.product-card-wrapper, .card, .swiper-slide');
            if (card) {
              productData = this.getProductDataFromCard(card);
            }
          }

          if (!productData) return;

          // Use quantity from productData (should always be provided from actual cart item)
          const quantity = productData.quantity || 1;

          const eventData = {
            event: 'cart_recommendation_add_to_cart',
            product_name: productData.name,
            product_id: productData.productId,
            product_handle: productData.handle,
            product_price: productData.price,
            product_brand: productData.brand,
            product_variant: productData.variant,
            product_variant_id: productData.variantId,
            product_category: productData.category,
            product_quantity: quantity,
            product_position: productData.position,
            currency: productData.currency,
            list_name: 'Cart Drawer Recommendations',
            recommendation_source: 'cart_drawer',
            recommendation_intent: productData.intent || this.intent,
          };

          // Send to GTM (dataLayer)
          if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push(eventData);
          }

          // Send to GA4 directly (gtag) if available
          if (typeof window.gtag === 'function') {
            window.gtag('event', 'add_to_cart', {
              currency: productData.currency,
              value: productData.price * quantity,
              items: [{
                item_id: productData.productId,
                item_name: productData.name,
                item_brand: productData.brand,
                item_category: productData.category,
                item_variant: productData.variant,
                price: productData.price,
                quantity: quantity,
                index: productData.position,
                item_list_name: 'Cart Drawer Recommendations',
                item_list_id: 'cart_drawer_recommendations',
              }],
            });
          }
        }

        trackRecommendationImpressions() {
          const slides = this.querySelectorAll('.swiper-slide');
          if (slides.length === 0) return;

          const items = [];
          slides.forEach((slide, index) => {
            const productData = this.getProductDataFromCard(slide);
            if (productData) {
              items.push({
                item_id: productData.productId,
                item_name: productData.name,
                item_brand: productData.brand,
                item_category: productData.category,
                item_variant: productData.variant,
                price: productData.price,
                currency: productData.currency,
                index: index + 1,
                item_list_name: 'Cart Drawer Recommendations',
                item_list_id: 'cart_drawer_recommendations',
              });
            }
          });

          if (items.length === 0) return;

          const eventData = {
            event: 'cart_recommendation_view',
            list_name: 'Cart Drawer Recommendations',
            recommendation_source: 'cart_drawer',
            recommendation_intent: this.intent,
            items_count: items.length,
          };

          // Send to GTM (dataLayer)
          if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push({
              ...eventData,
              ecommerce: {
                item_list_name: 'Cart Drawer Recommendations',
                item_list_id: 'cart_drawer_recommendations',
                items: items,
              },
            });
          }

          // Send to GA4 directly (gtag) if available
          if (typeof window.gtag === 'function') {
            window.gtag('event', 'view_item_list', {
              item_list_name: 'Cart Drawer Recommendations',
              item_list_id: 'cart_drawer_recommendations',
              items: items,
            });
          }
        }

        getProductDataFromCard(card) {
          const slide = card.closest('.swiper-slide');

          // First try to get data from data attributes (more reliable)
          if (slide) {
            const productId = slide.dataset.productId;
            const productHandle = slide.dataset.productHandle;
            const productTitle = slide.dataset.productTitle;
            const productPrice = parseFloat(slide.dataset.productPrice) || 0;
            const productPriceCents = slide.dataset.productPriceCents;
            const productVariantId = slide.dataset.productVariantId;
            const productVariantTitle = slide.dataset.productVariantTitle;
            const productType = slide.dataset.productType;
            const productVendor = slide.dataset.productVendor;
            const currency = slide.dataset.currency;

            if (productHandle && productTitle) {
              return {
                name: productTitle, // Clean product title from Liquid (no color in name)
                productId: productId, // Shopify product ID (used as 'id' in dataLayer)
                handle: productHandle, // Product handle
                variantId: productVariantId, // Shopify variant ID
                price: productPrice, // Numeric price for dataLayer (e.g., 99.99)
                priceCents: productPriceCents, // Price in cents for matching
                currency: currency, // Currency ISO code from cart
                brand: productVendor || 'Solbari',
                variant: productVariantTitle || '', // Actual variant title from Liquid
                category: productType || card.querySelector('.product-collection-info')?.textContent.trim() || '',
                position: Array.from(slide.parentElement.children).indexOf(slide) + 1,
              };
            }
          }

          // Fallback to DOM scraping if data attributes not available
          const titleElement = card.querySelector('.card__heading a, .card__heading');
          const priceElement = card.querySelector('.price-item--regular, .price__regular .price-item');
          const linkElement = card.querySelector('.card__heading a, .quick-add__mobile-link');

          if (!titleElement) return null;

          // Extract product handle from URL
          let productHandle = '';
          if (linkElement && linkElement.href) {
            const url = new URL(linkElement.href, window.location.origin);
            productHandle = url.pathname.split('/products/')[1]?.split('?')[0] || '';
          }

          return {
            name: titleElement.textContent?.trim() || '',
            id: productHandle,
            price: priceElement ? priceElement.textContent.trim() : '',
            brand: 'Solbari',
            variant: card.querySelector('.o-swatches__swatch-options .active')?.getAttribute('aria-label') || '',
            category: card.querySelector('.product-collection-info')?.textContent.trim() || '',
            position: slide ? Array.from(slide.parentElement.children).indexOf(slide) + 1 : 0,
          };
        }

        handleSwatchClick(event) {
          const button = event.currentTarget;
          const group = button.closest('.card__swatches, .o-swatches__swatch-options');
          if (!group) return;

          // Remove active from all buttons in group
          group.querySelectorAll('[data-colour-swatch-button]').forEach((b) => b.classList.remove('active'));

          // Add active to clicked button
          button.classList.add('active');

          // Update product image
          const card = button.closest('.product-card-wrapper, .card');
          if (!card) return;

          const img = card.querySelector('img');
          if (img) {
            if (button.dataset.varsrcset) {
              img.srcset = button.dataset.varsrcset;
            }
            if (button.dataset.varimage) {
              img.src = button.dataset.varimage;
            }
          }

          // Update quick-add button URL with selected variant
          const quickAddButton = card.querySelector('[data-product-url]');
          if (quickAddButton && button.dataset.variantUrl) {
            quickAddButton.setAttribute('data-product-url', button.dataset.variantUrl);
          }

          // Update mobile link URL with selected variant
          const swiperSlide = card.closest('.swiper-slide');
          const mobileLink = swiperSlide ? swiperSlide.querySelector('.quick-add__mobile-link') : null;
          if (mobileLink && button.dataset.variantUrl) {
            mobileLink.href = button.dataset.variantUrl;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["klaviyo-signup-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('custom-klaviyo-signup-form')) {
    class CustomKlaviyoSignUpForm extends HTMLElement{
        already_registered= "User already registered";
        successfully_registered= "Successfully registered";
        constructor() {
            super();
            this.form = this.querySelector('form');
            this.button = this.querySelector('[data-button]')
            const messagingDiv = this.querySelector('[data-messaging]');
            if (messagingDiv) {
                const messageDivData = JSON.parse(messagingDiv.innerHTML);
                this.already_registered = messageDivData?.already_registered || this.already_registered;
                this.successfully_registered = messageDivData?.successfully_registered || this.successfully_registered;
                messagingDiv.remove();
            }
            this.messageDiv = this.querySelector('[data-signup-message]');
            this.onSubmit = this.onSubmit.bind(this);
            this.form.addEventListener('submit', this.onSubmit);
        }
        onSubmit(e) {
            this.button.innerHTML = "Submitting...";
            e.preventDefault();
            const formData = new FormData(this.form);
            formData.append('$source', '$embed');
            formData.append('$method_id', 'embed');
            // Optionally, do client-side validation, disable button, show loading, etc.
            fetch(this.form.dataset.ajaxSubmit, {
                method: this.form.method,
                body: formData,
                headers: {
                    // fetch auto-sets multipart/form-data etc. If Klaviyo expects JSON or a particular content-type, adjust accordingly.
                }
            })
            .then(async response => {
                    if (response.ok) {
                        const jsonResponse = await response.json();
                        if (jsonResponse.data.is_subscribed) {
                            this.messageDiv.textContent = this.already_registered;
                        } else {
                            this.messageDiv.textContent = this.successfully_registered;
                        }
                        document.cookie = 'newsletter_subscribed=1; path=/; max-age=' + (60 * 60 * 24 * 365) + '; SameSite=Lax';
                        document.querySelectorAll('[data-hide-when-subscribed]').forEach(function (el) { el.style.display = 'none'; });
                        this.form.remove();
                        // success
                        this.form.reset();
                    } else {
                        return response.text().then(text => {
                        // show error
                            this.messageDiv.textContent = (response && response.message) || 'Something went wrong, please try again.';
                            console.error('Error response from Klaviyo:', text);
                        });
                    }
                    this.button.innerHTML = "Sign Up";
                })
                .catch(error => {
                    this.messageDiv.textContent = 'Network error, please try again.';
                    console.error('Network error:', error);
                    this.button.innerHTML = "Sign Up";
                });
        }
    }
    customElements.define('custom-klaviyo-signup-form', CustomKlaviyoSignUpForm);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('size-guide-popup')) {
    // One request per script, however many fit guides open it.
    const scriptLoads = new Map();
    const loadScript = (src) => {
      if (!scriptLoads.has(src)) {
        scriptLoads.set(
          src,
          new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = src;
            script.onload = resolve;
            script.onerror = () => {
              scriptLoads.delete(src);
              reject(new Error(`Failed to load ${src}`));
            };
            document.head.appendChild(script);
          })
        );
      }
      return scriptLoads.get(src);
    };

    customElements.define(
      'size-guide-popup',
      class SizeGuidePopup extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          const triggers = this.querySelectorAll('[data-size-guide-trigger]');
          if (!this.dialog || !triggers.length) return;

          this.heading = this.querySelector('[data-size-guide-title]');
          this.units = this.querySelector('[data-size-guide-units]');
          this.tabs = [...this.querySelectorAll('[data-size-guide-tab]')];
          this.panels = [...this.querySelectorAll('[data-size-guide-panel]')];

          // Each button opens the popup on its own tab.
          triggers.forEach((trigger) => {
            const panel = this.panel(trigger.dataset.sizeGuideTrigger);

            trigger.addEventListener('click', (event) => {
              event.preventDefault();
              this.select(panel);
              this.dialog.showModal();
              // showModal focuses the first control (the IN/CM switch), which shows a focus ring on phones:
              // focus the dialog itself instead. Tab still reaches the switch.
              this.dialog.focus();
              this.loadVisiblePane(panel);
              // The other unit and the other tabs load in the background, so switching is instant.
              this.panels.forEach((other) => this.preloadPanel(other, other === panel));
            });

            // Start loading on intent, so the content is usually in before the click.
            ['pointerenter', 'focus', 'touchstart'].forEach((type) =>
              trigger.addEventListener(type, () => this.preloadPane(this.visiblePane(panel)), { once: true, passive: true })
            );
          });

          // In an accordion, opening it is intent enough for the fit guides behind its buttons.
          const details = this.closest('details');
          const preloadFitGuides = () =>
            triggers.forEach((trigger) => this.preloadPane(this.visiblePane(this.panel(trigger.dataset.sizeGuideTrigger))));
          if (details?.open) {
            preloadFitGuides();
          } else {
            details?.addEventListener('toggle', () => details.open && preloadFitGuides());
          }

          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => {
              const panel = this.panel(tab.dataset.sizeGuideTab);
              this.select(panel);
              this.loadVisiblePane(panel);
            });
          });

          // Arrow keys, Home and End move between tabs (and select them), as in the ARIA tabs pattern.
          this.querySelector('[role="tablist"]')?.addEventListener('keydown', (event) => {
            const index = this.tabs.indexOf(document.activeElement);
            if (index === -1) return;
            const last = this.tabs.length - 1;
            const next = {
              ArrowRight: index === last ? 0 : index + 1,
              ArrowLeft: index === 0 ? last : index - 1,
              Home: 0,
              End: last,
            }[event.key];
            if (next === undefined) return;
            event.preventDefault();
            this.tabs[next].focus();
            this.tabs[next].click();
          });

          // Closing is animated in CSS (component-size-guide.css), so close() and Escape need no extra handling.
          this.querySelector('[data-size-guide-close]')?.addEventListener('click', () => this.dialog.close());

          // Closing returns focus to the button that opened the popup, which can show its focus ring. Drop it:
          // nothing shows focused, and the browser still continues from there on the next Tab.
          this.dialog.addEventListener('close', () => {
            if (this.contains(document.activeElement) && !this.dialog.contains(document.activeElement)) {
              document.activeElement.blur();
            }
          });

          // A click on the dialog itself (not its content) is a click on the backdrop.
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });

          // CSS hides whichever [data-unit-only] doesn't match data-unit; a fit guide pane that just
          // showed loads if it hasn't yet.
          this.querySelectorAll('.size-guide__unit-input').forEach((input) => {
            input.addEventListener('change', () => {
              this.dialog.dataset.unit = input.value;
              this.loadVisiblePane(this.activePanel());
            });
          });

          // The thumbnail follows the variant picker. Only this product's variants are in the map,
          // so changes from other products on the page (e.g. a quick add modal) are ignored.
          const thumbnail = this.querySelector('[data-size-guide-thumbnail]');
          const thumbnails = this.querySelector('[data-size-guide-thumbnails]');
          if (thumbnail && thumbnails && typeof subscribe === 'function') {
            const urls = JSON.parse(thumbnails.textContent);
            this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              const url = urls[event.data.variant?.id];
              if (url) thumbnail.src = url;
            });
          }
        }

        disconnectedCallback() {
          this.variantChangeUnsubscriber?.();
        }

        panel(key) {
          return this.panels.find((panel) => panel.dataset.sizeGuidePanel === key) || this.panels[0];
        }

        activePanel() {
          return this.panels.find((panel) => !panel.hidden);
        }

        // Shows a panel, with its tab, its title in the heading, and the unit switch unless it has a single unit.
        select(panel) {
          this.panels.forEach((other) => (other.hidden = other !== panel));
          this.tabs.forEach((tab) => {
            const selected = tab.dataset.sizeGuideTab === panel.dataset.sizeGuidePanel;
            tab.setAttribute('aria-selected', selected);
            tab.tabIndex = selected ? 0 : -1;
          });
          if (this.heading) this.heading.textContent = panel.dataset.title;
          if (this.units) this.units.hidden = panel.hasAttribute('data-single-unit');
        }

        // A panel's fit guide pane for the current unit. The size guide has none.
        visiblePane(panel) {
          const panes = [...panel.querySelectorAll('[data-fit-guide-pane]')];
          return panes.length === 1 ? panes[0] : panes.find((p) => p.dataset.unitOnly === this.dialog.dataset.unit);
        }

        loadVisiblePane(panel) {
          const pane = panel && this.visiblePane(panel);
          if (pane) this.loadPane(pane);
        }

        // The open panel's other unit, or another panel's current unit.
        preloadPanel(panel, open) {
          const visible = this.visiblePane(panel);
          panel.querySelectorAll('[data-fit-guide-pane]').forEach((pane) => {
            if (open ? pane !== visible : pane === visible) this.preloadPane(pane);
          });
        }

        // Before the pane shows: pages load fully (inserting into a hidden pane is fine), PDFs only load their
        // scripts, since the viewer measures the pane's width when it renders.
        preloadPane(pane) {
          if (!pane) return;
          if (pane.dataset.pageUrl) {
            this.loadPane(pane);
          } else if (pane.dataset.pdfUrl) {
            this.loadPdfScripts().catch(() => {});
          }
        }

        async loadPdfScripts() {
          // A test report on the same page may already have loaded pdf.js and the viewer.
          if (typeof window.pdfjsLib === 'undefined') await loadScript(this.dataset.pdfjsSrc);
          if (!window.PdfCanvasViewer) await loadScript(this.dataset.viewerSrc);
        }

        // Loads a pane's page or PDF once. PDFs render once visible, so they get its width.
        async loadPane(pane) {
          if (pane.dataset.loaded) return;
          pane.dataset.loaded = 'true';

          const page = pane.querySelector('[data-fit-guide-page]');
          if (page) {
            try {
              const response = await fetch(pane.dataset.pageUrl);
              if (!response.ok) throw new Error(`${response.status} ${pane.dataset.pageUrl}`);
              const html = new DOMParser().parseFromString(await response.text(), 'text/html');
              const main = html.getElementById('MainContent');
              if (!main) throw new Error(`No #MainContent in ${pane.dataset.pageUrl}`);
              page.replaceChildren(...main.childNodes);
              // Sections fade in on scroll; their observer only knows elements that existed on page load.
              if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(page);
            } catch (error) {
              delete pane.dataset.loaded;
              console.error('Fit guide page could not load', error);
            }
            return;
          }

          const viewer = pane.querySelector('.test-report-popup__pdf-viewer');
          if (!viewer || !pane.dataset.pdfUrl) return;

          try {
            await this.loadPdfScripts();
            new window.PdfCanvasViewer(viewer, pane.dataset.pdfUrl);
          } catch (error) {
            delete pane.dataset.loaded;
            console.error('Fit guide PDF could not load', error);
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-sizeguide-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-size-guide')) {
  let modalIdCounter = 0;

  customElements.define('product-size-guide', class ProductSizeGuide extends HTMLElement {
    constructor() {
      super();
      this.modalId = `size-guide-modal-${++modalIdCounter}`;
      this.initialized = false;
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      const trigger = this.querySelector('.size-guide-trigger');
      if (!trigger) return;

      const productTitle = this.dataset.productTitle || '';
      const sizeGuideContent = this.dataset.sizeGuideContent || '';
      // Store-level default unit (set in Theme settings > PDP > Size Guide).
      // 'cm' for the Australian and UK stores; defaults to 'in' elsewhere.
      const defaultCm = this.dataset.defaultUnit === 'cm';

      // Create modal HTML
      const dialogLabel = productTitle
        ? `${productTitle} ${"{{ 'products.product.size_fit_guide' | t: default: 'Size & Fit Guide' }}"}`
        : "{{ 'products.product.size_fit_guide' | t: default: 'Size & Fit Guide' }}";
      const modalHtml = `
        <div id="${this.modalId}" class="size-guide-modal" role="dialog" aria-modal="true" aria-label="${dialogLabel.replace(/"/g, '&quot;')}" tabindex="-1">
          <div class="modal-content">
            <button type="button" class="close" aria-label="{{ 'accessibility.close' | t: default: 'Close' }}">&times;</button>
            <div class="page-content">
              ${sizeGuideContent}
            </div>
          </div>
        </div>
      `;

      const toggleContent = `
        <div class='toggler-parent-wrapper'>
          <div>${productTitle}</div>
          <div class='toggler-btn-wrapper'>
            <div>IN</div>
            <form class="toggle-container">
              <label class="toggle-switch">
                <input type="checkbox" class="toggle-checkbox">
                <span class="slider"></span>
              </label>
            </form>
            <div>CM</div>
          </div>
        </div>
      `;

      // Insert modal into body
      document.body.insertAdjacentHTML('beforeend', modalHtml);

      // Get modal elements
      const modal = document.getElementById(this.modalId);
      const closeBtn = modal.querySelector('.close');
      const pageContent = modal.querySelector('.page-content');
      const table = pageContent?.querySelector('table');

      if (table) {
        const inchElems = pageContent.querySelectorAll('table td imperial');
        const dividerElems = pageContent.querySelectorAll('table td divider');
        const cmElems = pageContent.querySelectorAll('table td metric');

        // Dividers stay hidden; show whichever unit is the store default.
        this.toggleVisibility(dividerElems, false);
        this.toggleVisibility(inchElems, !defaultCm);
        this.toggleVisibility(cmElems, defaultCm);

        // Wrap table
        const wrapperDivTable = document.createElement('div');
        wrapperDivTable.className = 'toggler-and-table-wrapper';
        table.parentNode.insertBefore(wrapperDivTable, table);
        wrapperDivTable.appendChild(table);

        // Insert toggle content
        table.insertAdjacentHTML('beforebegin', toggleContent);

        // Setup toggle checkbox
        const toggleCheckbox = modal.querySelector('.toggle-checkbox');
        if (toggleCheckbox) {
          // Reflect the store default (checked = CM).
          toggleCheckbox.checked = defaultCm;
          toggleCheckbox.addEventListener('change', () => {
            if (toggleCheckbox.checked) {
              this.toggleVisibility(inchElems, false);
              this.toggleVisibility(cmElems, true);
            } else {
              this.toggleVisibility(inchElems, true);
              this.toggleVisibility(cmElems, false);
            }
          });
        }
      }

      // Track the element that opened the modal so focus can be restored on close.
      this.lastFocusedElement = null;

      const openModal = () => {
        this.lastFocusedElement = document.activeElement;
        modal.style.display = 'block';
        // Move keyboard focus into the dialog (the close button).
        closeBtn.focus();
      };

      const closeModal = () => {
        modal.style.display = 'none';
        // Return focus to the element that opened the modal.
        if (this.lastFocusedElement && typeof this.lastFocusedElement.focus === 'function') {
          this.lastFocusedElement.focus();
        } else {
          trigger.focus();
        }
      };

      // Event listeners
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        openModal();
      });

      closeBtn.addEventListener('click', () => {
        closeModal();
      });

      window.addEventListener('click', (e) => {
        if (e.target === modal) {
          closeModal();
        }
      });

      // Close on Escape when the modal is open.
      modal.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' || e.key === 'Esc') {
          e.preventDefault();
          closeModal();
        }
      });
    }

    disconnectedCallback() {
      // Clean up modal when element is removed
      const modal = document.getElementById(this.modalId);
      if (modal) {
        modal.remove();
      }
    }

    toggleVisibility(elements, show) {
      elements.forEach((element) => {
        if (element) {
          element.style.display = show ? '' : 'none';
        }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-to-button"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('scroll-to-button')) {
    class ScrollToButton extends HTMLElement {
        constructor() {
            super();
            this.onClick = this.onClick.bind(this);
            this.addEventListener('click', this.onClick);
        }
        onClick(e) {
            e.preventDefault();
            this.scrollTo = this.dataset.scrollTo;
            if (this.scrollTo !== "") {
                const header = document.querySelector(".section-header");
                const target = document.querySelector(this.scrollTo);

                if (!header || !target) return;

                const headerHeight =(header?.offsetHeight || 0) + (header?.getBoundingClientRect().top || 0);
                const targetPosition = target.getBoundingClientRect().top + window.scrollY;
                const offsetPosition = targetPosition - headerHeight;

                window.scrollTo({
                    behavior: "smooth",
                    top: offsetPosition
                });
            }
        }
    }
    customElements.define('scroll-to-button', ScrollToButton)
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-responsive"] && !Shopify.designMode) return;
  try {
    class LazyVideoResponsive {
    constructor(container) {
      this.container = container;
      this.mobileVideo = container.querySelector('.lazy-video-r[data-device="mobile"]');
      this.desktopVideo = container.querySelector('.lazy-video-r[data-device="desktop"]');
      this.mobilePoster = container.querySelector('.lazy-video-r-poster.mobile-only');
      this.desktopPoster = container.querySelector('.lazy-video-r-poster.desktop-only');
      this.mobilePlayBtn = container.querySelector('.lazy-video-r-play-btn[data-device="mobile"]');
      this.desktopPlayBtn = container.querySelector('.lazy-video-r-play-btn[data-device="desktop"]');
      
      this.hasMobileVideo = this.container.dataset.hasMobileVideo === 'true';
      this.hasDesktopVideo = this.container.dataset.hasDesktopVideo === 'true';
      this.currentDevice = this.getDeviceType();
      this.isLoaded = { mobile: false, desktop: false };
      this.isPlaying = false;
      this.isBuffering = false;
      
      this.init();
    }
    
    init() {
      // Check if component should be visible for current device
      const hasVideoForDevice = (this.currentDevice === 'mobile') ? this.hasMobileVideo : this.hasDesktopVideo;
      
      if (!hasVideoForDevice) {
        if (this.currentDevice === 'mobile' && !this.hasMobileVideo) {
          this.container.style.display = 'none';
        } else if (this.currentDevice === 'desktop' && !this.hasDesktopVideo) {
          this.container.style.display = 'none';
        }
        // Still set up resize listener for device switching
        window.addEventListener('resize', () => this.handleResize());
        return;
      }
      
      // Set up intersection observer for lazy loading
      if ('IntersectionObserver' in window) {
        this.setupIntersectionObserver();
      } else {
        this.loadCurrentVideo();
      }
      
      // Set up play button event handlers
      if (this.mobilePlayBtn) {
        this.mobilePlayBtn.addEventListener('click', () => this.handlePlayClick('mobile'));
        this.mobilePlayBtn.addEventListener('keydown', (e) => this.handleKeyDown(e, 'mobile'));
      }
      
      if (this.desktopPlayBtn) {
        this.desktopPlayBtn.addEventListener('click', () => this.handlePlayClick('desktop'));
        this.desktopPlayBtn.addEventListener('keydown', (e) => this.handleKeyDown(e, 'desktop'));
      }
      
      // Set up resize listener for device switching
      window.addEventListener('resize', () => this.handleResize());
      
      // Load responsive images
      this.loadResponsiveImages();
    }
    
    getDeviceType() {
      return window.innerWidth <= 767 ? 'mobile' : 'desktop';
    }
    
    getCurrentVideo() {
      if (this.currentDevice === 'mobile' && this.hasMobileVideo) {
        return this.mobileVideo;
      } else if (this.currentDevice === 'desktop' && this.hasDesktopVideo) {
        return this.desktopVideo;
      }
      return null;
    }
    
    getCurrentPlayBtn() {
      if (this.currentDevice === 'mobile' && this.hasMobileVideo) {
        return this.mobilePlayBtn;
      } else if (this.currentDevice === 'desktop' && this.hasDesktopVideo) {
        return this.desktopPlayBtn;
      }
      return null;
    }
    
    setupIntersectionObserver() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.isLoaded[this.currentDevice]) {
            // Only load if video exists for current device
            const hasVideo = (this.currentDevice === 'mobile') ? this.hasMobileVideo : this.hasDesktopVideo;
            if (hasVideo) {
              this.loadCurrentVideo();
              observer.unobserve(this.container);
            }
          }
        });
      }, {
        rootMargin: '50px 0px',
        threshold: 0.1
      });
      
      observer.observe(this.container);
    }
    
    loadResponsiveImages() {
      // Only load images for devices that have videos
      const postersToLoad = [];
      if (this.hasMobileVideo && this.mobilePoster) postersToLoad.push(this.mobilePoster);
      if (this.hasDesktopVideo && this.desktopPoster) postersToLoad.push(this.desktopPoster);
      
      postersToLoad.forEach(poster => {
        if (poster && poster.dataset.srcset) {
          poster.srcset = poster.dataset.srcset;
          poster.sizes = poster.dataset.sizes;
          poster.src = poster.dataset.srcset.split(' ')[0];
        }
      });
    }
    
    async loadCurrentVideo() {
      const device = this.currentDevice;
      if (this.isLoaded[device]) return;
      
      // Check if video exists for current device
      const hasVideo = (device === 'mobile') ? this.hasMobileVideo : this.hasDesktopVideo;
      if (!hasVideo) {
        // Hide container if no video exists for current device
        if ((device === 'mobile' && !this.hasMobileVideo) || (device === 'desktop' && !this.hasDesktopVideo)) {
          this.container.style.display = 'none';
        }
        return;
      }
      
      this.container.classList.add('loading');
      
      try {
        const video = this.getCurrentVideo();
        if (!video) {
          this.container.classList.remove('loading');
          return;
        }
        
        const sourcesData = device === 'mobile' 
          ? this.container.dataset.mobileSources 
          : this.container.dataset.desktopSources;
        
        if (!sourcesData || sourcesData === '[]') {
          this.container.classList.remove('loading');
          return;
        }
        
        const videoSources = JSON.parse(sourcesData);
        const autoplay = this.container.dataset.autoplay === 'true';
        const loop = this.container.dataset.loop === 'true';
        const muted = this.container.dataset.muted === 'true';
        const controls = this.container.dataset.controls === 'true';
        
        // Set video attributes
        if (!this.prefersReducedMotion()) {
          video.autoplay = autoplay;
        } else {
          video.autoplay = false;
        }
        video.loop = loop;
        video.muted = muted;
        video.controls = controls;
        
        // Clear existing sources
        video.innerHTML = '';
        
        // Sort sources by preference (MP4 first, then WebM, then others)
        const sortedSources = videoSources.sort((a, b) => {
          const formatPriority = { 'mp4': 0, 'webm': 1, 'mov': 2 };
          const aPriority = formatPriority[a.format] || 99;
          const bPriority = formatPriority[b.format] || 99;
          
          if (aPriority !== bPriority) {
            return aPriority - bPriority;
          }
          
          // If same format, prefer higher resolution
          return (b.width * b.height) - (a.width * a.height);
        });
        
        // Add source elements
        sortedSources.forEach(source => {
          if (source.url && source.mime_type) {
            const sourceElement = document.createElement('source');
            sourceElement.src = source.url;
            sourceElement.type = source.mime_type;
            video.appendChild(sourceElement);
          }
        });
        
        // Fallback: if no sources work, use the first MP4 as src
        const mp4Source = sortedSources.find(s => s.format === 'mp4');
        if (mp4Source) {
          video.src = mp4Source.url;
        }
        
        // Wait for video metadata to load
        await new Promise((resolve, reject) => {
          video.addEventListener('loadedmetadata', resolve, { once: true });
          video.addEventListener('error', reject, { once: true });
          video.load();
        });
        
        this.isLoaded[device] = true;
        this.container.classList.remove('loading');
        
        // Auto-play if enabled and user hasn't requested reduced motion
        if (autoplay && !this.prefersReducedMotion()) {
          this.play();
        }
        
      } catch (error) {
        console.warn(`Failed to load ${device} video:`, error);
        this.container.classList.remove('loading');
      }
    }
    
    async handleResize() {
      const newDevice = this.getDeviceType();
      
      if (newDevice !== this.currentDevice) {
        // Stop and hide current video
        this.stopAndHideVideo(this.currentDevice);
        
        // Switch to new device
        this.currentDevice = newDevice;
        
        // Check if the new device has a video available
        const hasVideoForDevice = (newDevice === 'mobile') ? this.hasMobileVideo : this.hasDesktopVideo;
        
        if (hasVideoForDevice) {
          // Show container if it was hidden
          this.container.style.display = '';
          
          // Load new video if needed
          if (!this.isLoaded[this.currentDevice]) {
            await this.loadCurrentVideo();
          } else {
            // If video is already loaded, handle autoplay for device switch
            const autoplay = this.container.dataset.autoplay === 'true';
            if (autoplay && !this.prefersReducedMotion()) {
              this.play();
            }
          }
        } else {
          // Hide container based on device and video availability
          if (newDevice === 'mobile' && !this.hasMobileVideo) {
            this.container.style.display = 'none';
          } else if (newDevice === 'desktop' && !this.hasDesktopVideo) {
            this.container.style.display = 'none';
          }
        }
      }
    }
    
    stopAndHideVideo(device) {
      const video = device === 'mobile' ? this.mobileVideo : this.desktopVideo;
      
      if (video) {
        // Always pause and reset video
        if (!video.paused) {
          video.pause();
        }
        video.currentTime = 0;
        
        // Remove sources to stop streaming and prevent memory leaks
        video.innerHTML = '';
        video.removeAttribute('src');
        video.load();
        
        // Mark as not loaded to force reload if needed later
        this.isLoaded[device] = false;
      }
      
      this.isPlaying = false;
      this.isBuffering = false;
      this.container.classList.remove('playing');
      this.updateButtonIcon();
    }
    
    prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
    
    handleKeyDown(e, device) {
      if (device !== this.currentDevice) return;
      
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.handlePlayClick(device);
      }
    }
    
    async handlePlayClick(device) {
      if (device !== this.currentDevice) return;
      
      if (!this.isLoaded[this.currentDevice]) {
        await this.loadCurrentVideo();
      }
      
      if (this.isPlaying) {
        this.pause();
      } else {
        this.play();
      }
    }
    
    async play() {
      const video = this.getCurrentVideo();
      if (!video || !this.isLoaded[this.currentDevice]) return;
      
      // Wait for sufficient buffer before playing
      if (!this.hasEnoughBuffer()) {
        this.isBuffering = true;
        this.updateButtonIcon();
        await this.waitForBuffer();
        this.isBuffering = false;
      }
      
      try {
        await video.play();
        this.isPlaying = true;
        this.container.classList.add('playing');
        this.updateButtonIcon();
      } catch (error) {
        console.warn('Failed to play video:', error);
        this.isBuffering = false;
        this.updateButtonIcon();
      }
    }
    
    hasEnoughBuffer() {
      const video = this.getCurrentVideo();
      if (!video) return false;
      
      // Check if video has enough metadata and data
      if (video.readyState < 3) { // HAVE_FUTURE_DATA
        return false;
      }
      
      // Check if we have buffered enough content
      if (video.buffered.length === 0) {
        return false;
      }
      
      const currentTime = video.currentTime;
      const bufferedEnd = video.buffered.end(video.buffered.length - 1);
      const bufferAhead = bufferedEnd - currentTime;
      
      // Require at least 3 seconds of buffer ahead
      return bufferAhead >= 3;
    }
    
    async waitForBuffer() {
      const video = this.getCurrentVideo();
      if (!video) return;
      
      return new Promise((resolve) => {
        const checkBuffer = () => {
          if (this.hasEnoughBuffer()) {
            resolve();
          } else {
            setTimeout(checkBuffer, 100);
          }
        };
        
        const onProgress = () => {
          if (this.hasEnoughBuffer()) {
            video.removeEventListener('progress', onProgress);
            video.removeEventListener('canplaythrough', onCanPlayThrough);
            resolve();
          }
        };
        
        const onCanPlayThrough = () => {
          video.removeEventListener('progress', onProgress);
          video.removeEventListener('canplaythrough', onCanPlayThrough);
          resolve();
        };
        
        video.addEventListener('progress', onProgress);
        video.addEventListener('canplaythrough', onCanPlayThrough);
        
        checkBuffer();
        
        setTimeout(() => {
          video.removeEventListener('progress', onProgress);
          video.removeEventListener('canplaythrough', onCanPlayThrough);
          resolve();
        }, 10000);
      });
    }
    
    pause() {
      const video = this.getCurrentVideo();
      if (!video || !this.isLoaded[this.currentDevice]) return;
      
      video.pause();
      this.isPlaying = false;
      this.isBuffering = false;
      this.container.classList.remove('playing');
      this.updateButtonIcon();
    }
    
    updateButtonIcon() {
      const playBtn = this.getCurrentPlayBtn();
      if (!playBtn) return;
      
      const playIcon = playBtn.querySelector('.play-icon');
      const pauseIcon = playBtn.querySelector('.pause-icon');
      const loadingIcon = playBtn.querySelector('.loading-icon');
      
      // Hide all icons first
      if (playIcon) playIcon.style.display = 'none';
      if (pauseIcon) pauseIcon.style.display = 'none';
      if (loadingIcon) loadingIcon.style.display = 'none';
      
      if (this.isBuffering) {
        if (loadingIcon) loadingIcon.style.display = 'block';
        playBtn.setAttribute('aria-label', 'Loading video');
        playBtn.setAttribute('title', 'Loading video');
        playBtn.setAttribute('aria-pressed', 'false');
        playBtn.disabled = true;
      } else if (this.isPlaying) {
        if (pauseIcon) pauseIcon.style.display = 'block';
        playBtn.setAttribute('aria-label', 'Pause video');
        playBtn.setAttribute('title', 'Pause video');
        playBtn.setAttribute('aria-pressed', 'true');
        playBtn.disabled = false;
      } else {
        if (playIcon) playIcon.style.display = 'block';
        playBtn.setAttribute('aria-label', 'Play video');
        playBtn.setAttribute('title', 'Play video');
        playBtn.setAttribute('aria-pressed', 'false');
        playBtn.disabled = false;
      }
    }
  }
  
  // Initialize responsive lazy videos when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    const lazyVideoContainers = document.querySelectorAll('.lazy-video-r-responsive-container');
    lazyVideoContainers.forEach(container => {
      new LazyVideoResponsive(container);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lazy-video-container')) {
  class LazyVideo extends HTMLElement {
    constructor() {
      super();
      this.container = this;
      this.video = this.querySelector('.lazy-video');
      this.poster = this.querySelector('.lazy-video-poster');
      this.playBtn = this.querySelector('.lazy-video-play-btn');
      this.isLoaded = false;
      this.isPlaying = false;
      this.handlePlayClick = this.handlePlayClick.bind(this);
      
      this.init();
    }
    
    init() {
      // Set up intersection observer for lazy loading
      if ('IntersectionObserver' in window) {
        this.setupIntersectionObserver();
      } else {
        // Fallback for older browsers
        this.loadVideo();
      }
      
      // Set up play button event handlers
      if (this.playBtn) {
        this.playBtn.addEventListener('click', this.handlePlayClick);
        this.playBtn.addEventListener('keydown', (e) => this.handleKeyDown(e));
      }
      
      // Lazy load responsive images
      this.loadResponsiveImage();
    }
    
    setupIntersectionObserver() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.isLoaded) {
            this.loadVideo();
            observer.unobserve(this.container);
          }
        });
      }, {
        rootMargin: '50px 0px',
        threshold: 0.1
      });
      
      observer.observe(this.container);
    }
    
    loadResponsiveImage() {
      const poster = this.poster;
      if (poster && poster.dataset.srcset) {
        poster.srcset = poster.dataset.srcset;
        poster.sizes = poster.dataset.sizes;
        poster.src = poster.dataset.srcset.split(' ')[0];
      }
    }
    
    async loadVideo() {
      if (this.isLoaded) return;
      
      this.container.classList.add('loading');
      
      try {
        const videoSources = JSON.parse(this.container.dataset.videoSources);
        const autoplay = this.container.dataset.autoplay === 'true';
        const loop = this.container.dataset.loop === 'true';
        const muted = this.container.dataset.muted === 'true';
        const controls = this.container.dataset.controls === 'true';
        
        // Set video attributes
        if (!this.prefersReducedMotion()) {
          this.video.autoplay = autoplay;
        } else {
          this.video.autoplay = false;
        }
        this.video.loop = loop;
        this.video.muted = muted;
        this.video.controls = controls;
        
        // Clear existing sources
        this.video.innerHTML = '';
        
        // Sort sources by preference (MP4 first, then WebM, then others)
        const sortedSources = videoSources.sort((a, b) => {
          const formatPriority = { 'mp4': 0, 'webm': 1, 'mov': 2 };
          const aPriority = formatPriority[a.format] || 99;
          const bPriority = formatPriority[b.format] || 99;
          
          if (aPriority !== bPriority) {
            return aPriority - bPriority;
          }
          
          // If same format, prefer higher resolution
          return (b.width * b.height) - (a.width * a.height);
        });
        
        // Add source elements
        sortedSources.forEach(source => {
          if (source.url && source.mime_type) {
            const sourceElement = document.createElement('source');
            sourceElement.src = source.url;
            sourceElement.type = source.mime_type;
            this.video.appendChild(sourceElement);
          }
        });
        
        // Fallback: if no sources work, use the first MP4 as src
        const mp4Source = sortedSources.find(s => s.format === 'mp4');
        if (mp4Source) {
          this.video.src = mp4Source.url;
        }
        
        // Wait for video metadata to load
        await new Promise((resolve, reject) => {
          this.video.addEventListener('loadedmetadata', resolve, { once: true });
          this.video.addEventListener('error', reject, { once: true });
          this.video.load();
        });
        
        this.isLoaded = true;
        this.container.classList.remove('loading');
        
        // Auto-play if enabled and user hasn't requested reduced motion
        if (autoplay && !this.prefersReducedMotion()) {
          this.play();
        }
        
      } catch (error) {
        console.warn('Failed to load video:', error);
        this.container.classList.remove('loading');
      }
    }
    
    prefersReducedMotion() {
      // Check if user prefers reduced motion
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
    
    handleKeyDown(e) {
      // Handle Enter and Space keys
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.handlePlayClick(e);
      }
    }
    
    async handlePlayClick(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!this.isLoaded) {
        await this.loadVideo();
      }
      
      if (this.isPlaying) {
        this.pause();
      } else {
        this.play();
      }
    }
    
    async play() {
      if (!this.isLoaded) return;
      
      // Wait for sufficient buffer before playing
      if (!this.hasEnoughBuffer()) {
        await this.waitForBuffer();
      }
      
      try {
        await this.video.play();
        this.isPlaying = true;
        this.container.classList.add('playing');
        this.updateButtonIcon();
      } catch (error) {
        console.warn('Failed to play video:', error);
      }
    }
    
    hasEnoughBuffer() {
      const video = this.video;
      
      // Check if video has enough metadata and data
      if (video.readyState < 3) { // HAVE_FUTURE_DATA
        return false;
      }
      
      // Check if we have buffered enough content
      if (video.buffered.length === 0) {
        return false;
      }
      
      const currentTime = video.currentTime;
      const bufferedEnd = video.buffered.end(video.buffered.length - 1);
      const bufferAhead = bufferedEnd - currentTime;
      
      // Require at least 3 seconds of buffer ahead
      return bufferAhead >= 3;
    }
    
    async waitForBuffer() {
      return new Promise((resolve) => {
        const checkBuffer = () => {
          if (this.hasEnoughBuffer()) {
            resolve();
          } else {
            // Check again after a short delay
            setTimeout(checkBuffer, 100);
          }
        };
        
        // Also resolve if we get these events
        const onProgress = () => {
          if (this.hasEnoughBuffer()) {
            this.video.removeEventListener('progress', onProgress);
            this.video.removeEventListener('canplaythrough', onCanPlayThrough);
            resolve();
          }
        };
        
        const onCanPlayThrough = () => {
          this.video.removeEventListener('progress', onProgress);
          this.video.removeEventListener('canplaythrough', onCanPlayThrough);
          resolve();
        };
        
        this.video.addEventListener('progress', onProgress);
        this.video.addEventListener('canplaythrough', onCanPlayThrough);
        
        // Start checking
        checkBuffer();
        
        // Timeout after 10 seconds to avoid infinite waiting
        setTimeout(() => {
          this.video.removeEventListener('progress', onProgress);
          this.video.removeEventListener('canplaythrough', onCanPlayThrough);
          resolve();
        }, 10000);
      });
    }
    
    pause() {
      if (!this.isLoaded) return;
      
      this.video.pause();
      this.isPlaying = false;
      this.container.classList.remove('playing');
      this.updateButtonIcon();
    }
    
    updateButtonIcon() {
      if (!this.playBtn) return;
      
      if (this.isPlaying) {
        // Show pause icon, hide play icon
        if (this.playIcon) this.playIcon.style.display = 'none';
        if (this.pauseIcon) this.pauseIcon.style.display = 'block';
        this.playBtn.setAttribute('aria-label', 'Pause video');
        this.playBtn.setAttribute('title', 'Pause video');
        this.playBtn.setAttribute('aria-pressed', 'true');
      } else {
        // Show play icon, hide pause icon
        if (this.playIcon) this.playIcon.style.display = 'block';
        if (this.pauseIcon) this.pauseIcon.style.display = 'none';
        this.playBtn.setAttribute('aria-label', 'Play video');
        this.playBtn.setAttribute('title', 'Play video');
        this.playBtn.setAttribute('aria-pressed', 'false');
      }
    }
  }
    customElements.define('lazy-video-container', LazyVideo);
  }
  } catch(e) { console.error(e); }
})();

})();
